import { Button } from '@mui/material'
import { green, grey } from '@mui/material/colors'
import React from 'react'
function HeureComponent({ type, disabledHours, onChangeHeure, activeHours }) {
    const plage_matin = ['08:00', '08:15','08:30','08:45', '09:00','09:15','09:30','09:45', '10:00', '10:15', '10:30','10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30']
    const plage_midi = ['14:00','14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00']
    const changeHeure = (e) => {
        const heure = e.target.value
        const status = e.target.disabled
        onChangeHeure(heure, status)
    }

    return (
        <div>
            {type == 'matin' && (
                <>
                    {plage_matin.map((matin) => {
                        var disabledStatusMatin = disabledHours ? disabledHours.includes(matin) : false
                        return (
                            <Button variant="contained" value={matin} onClick={changeHeure} disabled={disabledStatusMatin} color={matin == activeHours ? 'error' : 'success'} size='small' style={{
                                margin: 1, backgroundColor: matin === activeHours ? '#d82967' : disabledStatusMatin?grey[400]:green[700]
                            }} key={matin}>{matin}</Button>
                        )
                    })}
                </>

            )}
            {type == 'midi' && (
                <>
                    {plage_midi.map((midi) => {
                        var disabledStatusMidi = disabledHours ? disabledHours.includes(midi) : false
                        return (
                            <Button variant="contained" key={midi} value={midi} onClick={changeHeure} disabled={disabledStatusMidi} color={midi == activeHours ? 'error' : 'success'} size='small' style={{
                                margin: 1, backgroundColor: midi === activeHours ? '#d82967' : disabledStatusMidi?grey[400]:green[700]
                            }}>{midi}</Button>
                        )
                    })}
                </>

            )}
        </div>
    )
}

export default HeureComponent